import "../src/App.css";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Home from "./components/Home";
import Terms from "./components/Terms";
import Privacy from "./components/Privacy";
import DeleteData from "./components/DeleteData";
import DeleteAccount from "./components/DeleteAccount";
import SupportForm from "./components/Support";

function App() {
  return (
    <Router>
      {/* A <Switch> looks through its children <Route>s and
            renders the first one that matches the current URL. */}
      <Switch>
        <Route path="/decohouse-terms">
          <Terms />
        </Route>
        <Route path="/decohouse/delete-data">
          <DeleteData />
        </Route>
        <Route path="/decohouse/delete-account">
          <DeleteAccount />
        </Route>
        <Route path="/decohouse/support">
          <SupportForm />
        </Route>
        <Route path="/decohouse-privacy">
          <Privacy />
        </Route>
        <Route path="/">
          <Home />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
